export const REGISTER_USER_REQUEST = "USER.REGISTER_USER_REQUEST";
export const REGISTER_USER_SUCCESS = "USER.REGISTER_USER_SUCCESS";
export const REGISTER_USER_FAILURE = "USER.REGISTER_USER_FAILURE";

export const GET_ALL_USERS_REQUEST = "USER.GET_ALL_USERS_REQUEST";
export const GET_ALL_USERS_SUCCESS = "USER.GET_ALL_USERS_SUCCESS";
export const GET_ALL_USERS_FAILURE = "USER.GET_ALL_USERS_FAILURE";

export const CHANGE_USER_AUTH_REQUEST = "USER.CHANGE_USER_AUTH_REQUEST";
export const CHANGE_USER_AUTH_SUCCESS = "USER.CHANGE_USER_AUTH_SUCCESS";
export const CHANGE_USER_AUTH_FAILURE = "USER.CHANGE_USER_AUTH_FAILURE";
